import { environment } from "@env/environment";

export const scriptTags = [
	// {
	// 	name: 'googletag',
	// 	url: '../assets/scripts/gtags.js',
	// 	location: 'head',
	// 	renderOnlyForProd: !environment.appendNofllow,
	// },
	{
		name: 'pageTitle',
		url: '../assets/scripts/ptitle.js',
		location: 'head',
		renderOnlyForProd: !environment.appendNofllow,
	},
	// {
	// 	name: 'roomvo',
	// 	url: 'https://cdn.roomvo.com/static/scripts/b2b/mohawkflooring.js',
	// 	location: 'head',
	// 	renderOnlyForProd: true,
	// },
	{
		name: 'hotjar',
		url: '../assets/scripts/hotjar.js',
		location: 'head',
		renderOnlyForProd: !environment.appendNofllow,
	},
	{
		name: 'fb',
		url: '../assets/scripts/fb.js',
		location: 'body',
		renderOnlyForProd: !environment.appendNofllow,
	},
	{
		name: 'connect-fb',
		url: '../assets/scripts/connect-fb.js',
		location: 'body',
		renderOnlyForProd: !environment.appendNofllow,
	},
	{
		name: 'audioeye',
		url: '../assets/scripts/audioeye.js',
		location: 'body',
		renderOnlyForProd: !environment.appendNofllow,
	},
	{
		name: 'hsforms',
		url: '//js.hsforms.net/forms/embed/v2.js',
		location: 'head',
		renderOnlyForProd: true,
	},
];
export const initialLoadScriptTags = [
	{
		name: 'googletag',
		url: '../assets/scripts/gtags.js',
		location: 'head',
		renderOnlyForProd: !environment.appendNofllow,
	}
];